import React from 'react';

const WellcomeText = (props) => {
  return (
    <div className="tc pv2 black bg-washed-green">
      {/* <p className="f5  blue">Welcome to PKBM</p> */}
      <p className="f2"> Welcome to PKBM Hanuba Medan</p>
      <div className=' tc'>
      <p className="f6 tc ">
        PKBM HANUBA merupakan sekolah yang membantu masyarakat untuk memperoleh
        pendidikan dan pengajaran, menyelenggarakan pendidikan luar <br/>sekolah atau 
        pendidikan non formal dan mengadakan pelatihan- pelatihan keterampilan 
        maupun kewirausahaan serta mengupayakan penambahan pengetahuan masyarakat.</p>
        </div>
    </div>
  );
};

export default WellcomeText;